import * as Yup from 'yup';

import { requirePasswordValidation } from 'helpers/validate';

export const loginSchema = Yup.object().shape({
  account: Yup.string().required(),
  password: requirePasswordValidation,
});
